export enum FeatureFlagKeys {
  Use_CL_Test_RS_Date = 'Use_CL_Test_RS_Date',
  Use_CL_Fullvideo_Facerec = 'Use_CL_Fullvideo_Facerec',
  Use_CL_Fullvideo_Facerec_Pre_Recorded = 'Use_CL_Fullvideo_Facerec_Pre_Recorded',
  Use_CL_Splits_Translations = 'Use_CL_Splits_Translations',
  Use_CL_Screenshare_Detection = 'Use_CL_Screenshare_Detection',
  Use_CL_Init_New_Player_Config = 'Use_CL_Init_New_Player_Config',
  Use_CL_Face_Rec_To_Default_Position = 'Use_CL_Face_Rec_To_Default_Position',
  Use_CL_Platform_Brandkit = 'Use_CL_Platform_Brandkit'
}

export class FeatureFlags {
  private flags: Record<FeatureFlagKeys, any>;
  constructor(flags: Record<FeatureFlagKeys, any>) {
    this.flags = flags;
    Object.values(FeatureFlagKeys).forEach(flagName => {
      if (!(flagName in this.flags)) {
        console.warn(`Missing ${flagName} in ${this.flags}`);
      }
    });
  }

  public getFlag(flagName: FeatureFlagKeys) {
    const flagValue = this.flags[flagName];
    // eslint-disable-next-line no-console
    console.log({ flagName, flagValue });
    return flagValue;
  }

  public getNumberFlag(flagName: FeatureFlagKeys) {
    const flagValue = Number(this.flags[flagName]);
    // eslint-disable-next-line no-console
    console.log({ flagName, flagValue });
    return flagValue;
  }
}
